export default __webpack_public_path__ + "static/team-member-3-b367676a027748e9e101eb215d8ae842.png";